module.exports = __webpack_public_path__ + "img/ACD_LOGO_White.7fb0f75a.svg";